import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { ToasterService } from './toast.service';
import { GenericService } from './generic.service';

@Injectable({ providedIn: 'root' })
export class PwaService extends GenericService<any> {
	constructor(
		private http: HttpClient,
		private toasterService: ToasterService
	) {
		super(http);
	}

	getPwa(subdomain: string): Observable<any> {
		return this.http.get<any>(`${environment.api}/${subdomain}`).pipe(
			catchError((error) => {
				return throwError(() => error);
			})
		);
	}

	getPwaThemes(subdomain: string): Observable<any> {
		return this.http.get<any>(`${environment.api}/${subdomain}/image`).pipe(
			catchError((error) => {
				return throwError(() => error);
			})
		);
	}
}
